<template>
  <div>
    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="agent_bill_id"
    >
      <div slot="agents_product_name" slot-scope="agents_product_name, record">
        <router-link
          :to="{ name: 'monthly_bill_card_use_info',
                 params: { card_use_id: record.product_usage_order_id },
                 query: { bill_id: billId }}"
        >
          {{ agents_product_name }}
        </router-link>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { findCardUseBills } from '@/api/agent_monthly_bill'
import { formatBigNumber, formatCurrency } from '@/utils/filter'

export default {
  name: 'AgentPurchaseBillList',
  components: {
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  props: {
    billId: {
      type: Number,
      required: true
    }
  },
  computed: {
    columns() {
      return [
        { title: '套餐名称', dataIndex: 'agents_product_name', scopedSlots: { customRender: 'agents_product_name' }},
        { title: '单元类型', dataIndex: 'user_business_type' },
        { title: '活跃卡号总数', dataIndex: 'activated_card_count', customRender: formatBigNumber },
        { title: '超额费用(元)', dataIndex: 'exceed_fee', customRender: formatCurrency },
        { title: '总费用(元)', dataIndex: 'total_fee', customRender: formatCurrency },
        { title: '备注', dataIndex: 'remark', ellipsis: true }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      findCardUseBills(this.billId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>

